import Cookies from 'js-cookie';

export default {
  name: 'bookmarks',

  getReducer: () => {
    const initialData = {
      shouldGetCookie: true,
      shouldSetCookie: false,
      data: [],
      animIdx: 0,
      isAnimating: false
    }

    return (state = initialData, { type, payload }) => {
      switch(type){
        case 'BOOKMARK_RETRIVED':
        case 'BOOKMARK_SET_COOKIE':       
        case 'BOOKMARK_SAVED':
        case 'BOOKMARK_DELETED':
          return Object.assign({}, state, payload);
        case 'BOOKMARK_ANIMATION_INCREMENT':
          return Object.assign({}, state, payload);
        case 'BOOKMARK_ANIMATION_STARTED':
          return Object.assign({}, state, {
            isAnimating: true
          });
        case 'BOOKMARK_ANIMATION_STOPPED':
            return Object.assign({}, state, {
              animIdx: 0,
              isAnimating: false
            });
        default:
          return state;
      }      
    }
  },
  doGetCookieBookmark: (bookmark) => ({ dispatch, store }) => {
    dispatch({type: 'BOOKMARK_RETRIVED', payload: {shouldGetCookie: false}});
    const bookmarks = Cookies.get('bookmarks');
    let bmArr =[];
    if(bookmarks) {
      bmArr= JSON.parse(bookmarks);
    }
    dispatch({type: 'BOOKMARK_SAVED', payload: { data: bmArr }});
    
  },
  doSetCookieBookmark: () => ({ dispatch, store }) => {
    dispatch({type: 'BOOKMARK_SET_COOKIE', payload: {shouldSetCookie: false}});
    const bookmarks = store.selectBookmarks();

    Cookies.set('bookmarks', bookmarks)
  },

  doSaveBookmark: (bookmark) => ({ dispatch, store }) => {
    const bookmarks = store.selectBookmarks().slice()
    bookmarks.push(bookmark);
    dispatch({type: 'BOOKMARK_SAVED', payload: { data: bookmarks, shouldSetCookie: true }});
  },

  doDeleteBookmark: (bookmark) => ({ dispatch, store }) => {
    const bookmarks = store.selectBookmarks().slice();
    const idx = bookmarks.indexOf(bookmark);
    bookmarks.splice(idx, 1);
    dispatch({type: 'BOOKMARK_DELETED', payload: { data: bookmarks, shouldSetCookie: true }});
  },

  doGoToBookmark: (bookmark) => ({ dispatch, store }) => {
    store.doSetView(bookmark);
    dispatch({type: 'BOOKMARK_NAVIGATED'})
  },

  doIncrementBookmarkAnimation: () => ({dispatch, store}) => {
    const len = store.selectBookmarksLength();
    const currentIdx = store.selectBookmarkAnimationIdx();
    const newIdx = (currentIdx + 1) % len;
    dispatch({type: 'BOOKMARK_ANIMATION_INCREMENT', payload: { animIdx: newIdx }})
  },

  doStartBookmarkAnimation: () => ({dispatch}) => {
    dispatch({type: 'BOOKMARK_ANIMATION_STARTED'});
  },

  doStopBookmarkAnimation: () => ({dispatch}) => {
    dispatch({type: 'BOOKMARK_ANIMATION_STOPPED'});
  },

  selectBookmarks: (state) => {
    return state.bookmarks.data;
  },

  selectBookmarksLength: (state) => {
    return state.bookmarks.data.length;
  },

  selectBookmarksIsAnimating: (state) => {
    return state.bookmarks.isAnimating;
  },

  selectBookmarkAnimationIdx: (state) => {
    return state.bookmarks.animIdx;
  },
  reactBookmarksShouldGetCookieBookmark: (state) => {
    if(state.bookmarks.shouldGetCookie) return { actionCreator: 'doGetCookieBookmark' };
  },
  reactBookmarksShouldSetCookieBookmark: (state) => {
    if(state.bookmarks.shouldSetCookie) return { actionCreator: 'doSetCookieBookmark' };
  },
  persistActions: ['BOOKMARK_SAVED', 'BOOKMARK_DELETED']
}